import React, { useState } from "react";
import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getBusinessGroupDetail } from "PlatForms/OrgLMS/Services/AdminServices/CourseListService";
import { Button, Modal, message, Input, Card, List, Typography, Divider, Spin } from "antd";
import { PlusOutlined,  CalendarOutlined,CheckCircleOutlined } from '@ant-design/icons';
import { addBusinessGroupField } from "PlatForms/OrgLMS/Services/AdminServices/CourseListService";
const { Title, Text } = Typography;
const BusinessGroupDetail = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const { businessGroupId, businessGroupName } = location.state || {};
    const [loading, setLoading] = useState(false);
    const [groupDetail, setGroupDetail] = useState(null);
    const [showModel, setShowModel] = useState(false);
    const [newFieldName, setNewFieldName] = useState("");
    const [saving, setSaving] = useState(false);
    useEffect(() => {
        if (businessGroupId) {
            fetchBusinessGroupDetail();
        }
        else {
            message.warning("There is no Business Group Id located");
        }
    }, [businessGroupId]);

    const fetchBusinessGroupDetail = async () => {
        try {
            setLoading(true);
            const data = await getBusinessGroupDetail(businessGroupId);
            console.log("............", data)
            setGroupDetail(data);
        }
        catch (error) {
            console.error("Error fetching Business Group Detail", error);
        } finally {
            setLoading(false);
        }
    };

    const handleAddField = async () => {
        if (!newFieldName.trim()) {
            message.warning("Please enter Field Name ");
            return;
        }
        try {
            setSaving(true);
            const newField = {
                name: newFieldName,
                businessGroupId: businessGroupId
            };
            await addBusinessGroupField(newField);
            await fetchBusinessGroupDetail();
            message.success({
            content: `Field "${newFieldName}" added successfully!`,
            duration: 2.5,
            className: 'custom-toast-success',
            icon: <CheckCircleOutlined />
        });

            setNewFieldName("");
            setShowModel(false);
        }
        catch (error) {
            message.error("Fails")

        } finally {
            setSaving(false);
        }

    };

    return (
        <Card className="card-professional"
            title={` Business Group detail for: ${businessGroupName}`}
            extra={<Button type="default" onClick={() => navigate("/business-groups/list")}>
                Back
            </Button>}
        >
            {loading ? (
                <div style={{ textAlign: 'center', padding: '24px' }}>
                    <Spin size="large" />
                </div>
            ) : groupDetail && (
                <div>
                    <div style={{ marginBottom: '24px' }}>
                        <Title level={4} style={{ marginBottom: '4px' }}>{groupDetail.name}</Title>
                        <Text type="secondary">
                            <CalendarOutlined style={{ marginRight: '8px' }} />
                            Created on: {new Date(groupDetail.createdOn).toLocaleDateString()}
                        </Text>
                    </div>

                    <Divider orientation="left" plain >
                        <strong>  Fields</strong>
                    </Divider>

                    {groupDetail.fields?.length > 0 ? (
                        <List
                            size="small"
                            bordered
                            dataSource={groupDetail.fields}
                            renderItem={field => (
                                <List.Item>
                                    <Text>{field.name}</Text>
                                </List.Item>
                            )}
                        />
                    ) : (
                        <Text type="secondary">No fields added yet</Text>
                    )}

                    <div style={{ marginTop: '16px' }}>
                        <Button
                            type="primary"
                            icon={<PlusOutlined />}
                            onClick={() => setShowModel(true)}
                        >
                            Add Field
                        </Button>
                    </div>

                    <Modal
                        title="Add New Field"
                        open={showModel}
                        onOk={handleAddField}
                        onCancel={() => setShowModel(false)}
                        confirmLoading={saving}
                        okText="Save"
                        cancelText="Cancel"
                    >
                        <Input
                            placeholder="Enter field name"
                            value={newFieldName}
                            onChange={(e) => setNewFieldName(e.target.value)}
                            onPressEnter={handleAddField}
                        />
                    </Modal>
                </div>
            )}


        </Card>

    )
}

export default BusinessGroupDetail;